/*jshint esversion: 11 */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalFooter,
  Input,
  Container,
  CardBody,
  Card,
  InputGroup, InputGroupAddon, InputGroupText,
  Badge,
  Table,
  ModalHeader,
  ModalBody,
  Spinner,
  Form,
  Alert,
  Collapse
} from 'reactstrap';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { getBatchExecutionChildrenList, getBatchInfo } from '../../api/batch';
import PageDataLoader from '../Utility/PageDataLoader';
import { addNewBatchExecution, bulkExecutionPublish, fetchExecutionHistory, updateExecution } from '../../api/execution';
import FormUpload from '../../components/FormUpload';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import moment from 'moment';
import { isValidYouTubeLink } from '../../helpers/expression-checker';
import { validatePermissionKey } from '../../helpers/permission';
import {
  DELETE_EXECUTION,
  UPDATE_EXECUTION,
} from '../Utility/PermissionKeys';
import ExecutionCarousel from '../Child/ExecutionCarousel';
import UpdateExecutionModal from '../Child/UpdateExecutionModal';
import DeleteExecutionModal from '../Child/DeleteExecutionModal';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useHistory } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';

const AddBatchExecution = (props) => {
  const { batchId } = useParams();
  const history = useHistory();

  const [date, setDate] = useState(
    new Date() >= new Date(props?.location?.state?.batchStartDate) &&
      new Date() <= new Date(props?.location?.state?.batchEndDate)
      ? new Date()
      : history.location.state.date ? new Date(history.location.state.date) : new Date(props?.location?.state?.batchStartDate)
  );

  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });

  const [successAlert, setSuccessAlert] = useState({
    message: '',
    show_alert: false
  });
  const [loading, setLoading] = useState(false);

  const [childOptions, setChildOptions] = useState([]);
  const [noteRequired, setNoteRequired] = useState(true);

  const [addExecutionModalVisible, setAddExecutionModalVisible] = useState(false);
  const [executionHistory, setExecutionHistory] = useState([]);
  const [reload, setReload] = useState(false);

  // States for modals
  const [viewModal, setViewModal] = useState({
    open: false,
    execution: null
  });

  const [updateModal, setUpdateModal] = useState({
    open: false,
    executionId: null
  });

  const [deleteModal, setDeleteModal] = useState({
    open: false,
    executionId: null,
    requestType: null
  });

  const openAddBatchExecutionModal = () => {
    setAddExecutionModalVisible(true);
  };

  const closeAddBatchExecutionModal = () => {
    setAddExecutionModalVisible(false);
  };

  const openViewModal = (execution) => {
    setViewModal({
      open: true,
      execution: execution
    });
  };

  const closeViewModal = () => {
    setViewModal({
      open: false,
      execution: null
    });
  };

  const openUpdateExecutionModal = (executionId) => {
    setUpdateModal({
      open: true,
      executionId: executionId
    });
  };

  const closeUpdateExecutionModal = () => {
    setUpdateModal({
      open: false,
      executionId: null
    });
  };

  const openDeleteExecutionModal = (executionId, requestType) => {
    setDeleteModal({
      open: true,
      executionId: executionId,
      requestType: requestType
    });
  };

  const closeDeleteExecutionModal = () => {
    setDeleteModal({
      open: false,
      executionId: null,
      requestType: null
    });
  };

  const [breadcrumbItems] = useState([
    { title: 'Batch', link: '/batches' },
    { title: 'Add Batch Execution', link: '#' }
  ]);

  const fetchBatchExecutionHistory = async (date, batch) => {
    setLoading(true);
    const { response, error } = await fetchExecutionHistory(moment(new Date(date)).format(
      'YYYY-MM-DD'
    ), batchId);
    if (error) {
      showErrorAlert("Error in fetching executions");
      setLoading(false);
    }
    else {
      setExecutionHistory(response.data);
      setLoading(false);
    }
  };

  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  function showSuccessAlert(message) {
    setSuccessAlert({ message: message, show_alert: true });
  }

  function resetSuccessAlert() {
    setSuccessAlert({ message: '', show_alert: false });
  }

  let listElem = document.getElementById('batchList');
  let linkElem = document.getElementById('batchLink');

  useEffect(() => {
    if (listElem) listElem.classList.add('mm-active');
    if (linkElem) linkElem.classList.add('active');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.authUser, listElem, linkElem]);

  useEffect(() => {
    fetchBatchExecutionHistory(date, batchId);
    fetchChildOptions(date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, reload]);

  useEffect(() => {
    async function fetchBatchInfo() {
      const batchInfo = await getBatchInfo(batchId);
      if (batchInfo) {
        setNoteRequired(batchInfo.noteRequired !== false);
      }
    }
    fetchBatchInfo();
  }, [batchId]);

  const fetchChildOptions = async (
    selectedDate,
    current_page = 1,
    page_limit = 100
  ) => {
    const response = await getBatchExecutionChildrenList(
      props.match.params.batchId,
      selectedDate,
      current_page,
      page_limit
    );
    if (response) {
      setChildOptions(buildOptions(response?.data || []));
    } else {
      return;
    }
  };

  function buildOptions(list) {
    return list.map((item) => ({
      value: item._id,
      label: item.name
    }));
  }

  async function bulkPublishExecutions() {
    setLoading(true);
    const { error } = await bulkExecutionPublish(date);
    if (error) {
      showErrorAlert("Error in bulk publishing");
      setLoading(false);
    }
    else {
      showSuccessAlert("All drafted executions published");
      setLoading(false);
      setReload(!reload);
    }
  }

  // Handle publishing a single execution
  const handlePublishExecution = async (executionId) => {
    setLoading(true);
    const formData = new FormData();
    formData.set("draft", false);
    const { response, error } = await updateExecution(executionId, formData);
    if (error) {
      showErrorAlert("Error in publishing execution");
      setLoading(false);
    } else {
      showSuccessAlert("Execution published successfully");
      setLoading(false);
      setReload(!reload);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {addExecutionModalVisible && (
          <AddBatchExecutionModal
            addExecutionModalVisible={addExecutionModalVisible}
            setLoading={setLoading}
            close={closeAddBatchExecutionModal}
            date={date}
            showSuccessAlert={showSuccessAlert}
            setSuccessAlert={setSuccessAlert}
            childOptions={childOptions}
            setChildOptions={setChildOptions}
            batchId={batchId}
            noteRequired={noteRequired}
            reload={reload}
            setReload={setReload}
            existingExecutions={executionHistory}
          />
        )}

        {/* View Multimedia Modal */}
        <Modal isOpen={viewModal.open} toggle={closeViewModal} size="lg">
          <ModalHeader toggle={closeViewModal}>View Multimedia</ModalHeader>
          <ModalBody>
            {viewModal.execution && (
              <>
                {viewModal?.execution?.images && <ExecutionCarousel
                  executionID={viewModal.execution._id}
                  images={viewModal.execution.images}
                  reload={reload}
                  setReload={setReload}
                  history={true}
                />}
                {/* <div className="mt-4">
                  <h5>YouTube Links:</h5>
                  {viewModal.execution.links && viewModal.execution.links.length > 0 ? (
                    <ul>
                      {viewModal.execution.links.map((link, index) => (
                        <li key={index}>
                          <a href={link} target="_blank" rel="noopener noreferrer">
                            {link}
                          </a>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No YouTube links available</p>
                  )}
                </div> */}
                <div className="mt-4">
                  <h5>Note:</h5>
                  <p>{viewModal.execution.note}</p>
                </div>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={closeViewModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>

        {/* Update Execution Modal */}
        {updateModal.open && (
          <UpdateExecutionModal
            modalOpenState={updateModal.open}
            closeModalHandler={closeUpdateExecutionModal}
            executionId={updateModal.executionId}
            authUser={props.authUser}
            date={date}
            reload={reload}
            setReload={setReload}
            history={true}
          />
        )}

        {/* Delete Execution Modal */}
        {deleteModal.open && (
          <DeleteExecutionModal
            modalOpenState={deleteModal.open}
            closeModalHandler={closeDeleteExecutionModal}
            executionId={deleteModal.executionId}
            type={deleteModal.requestType}
            reload={reload}
            setReload={setReload}
            history={true}
            date={date}
          />
        )}

        {successAlert.show_alert && (
          <SweetAlert
            success
            title="Created"
            onConfirm={resetSuccessAlert}
          >
            {successAlert.message}
          </SweetAlert>
        )}
        {requestError.show_alert && (
          <SweetAlert error title={requestError.message} onConfirm={resetErrorAlert}>
            {requestError.message}
          </SweetAlert>
        )}
        {loading ? (
          <div className="d-flex justify-content-center">
            <PageDataLoader />
          </div>
        ) : (
          <Container fluid>
            <Breadcrumbs
              title={props.location.state.batchName}
              breadcrumbItems={breadcrumbItems}
            />
            <Card>
              <CardBody>
                <AvForm className="needs-validation">
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Date</Label>
                        <AvField
                          name="date"
                          placeholder="Date ..."
                          type="date"
                          min={
                            props.location.state.batchStartDate &&
                            props.location.state.batchStartDate.split('T')[0]
                          }
                          max={
                            props.location.state.batchEndDate &&
                            props.location.state.batchEndDate.split('T')[0]
                          }
                          className="form-control"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: 'Date is required'
                            }
                          }}
                          onChange={async (e) => {
                            setDate(e.target.value);
                          }}
                          defaultValue={moment(new Date(date)).format(
                            'YYYY-MM-DD'
                          )}
                          helpMessage="Date should lie between batch start and end date"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6" className="text-right d-flex justify-content-end align-items-center">
                      <div className="d-flex gap-2">
                        <Button
                          color="success"
                          className="mr-2"
                          onClick={bulkPublishExecutions}
                          disabled={executionHistory.length === 0}
                          size='sm'
                        >
                          Bulk Publish Executions
                        </Button>
                        <Button
                          size='sm'
                          color="primary"
                          onClick={openAddBatchExecutionModal}
                        >
                          Add Execution
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Table striped responsive>
                        <thead>
                          <tr>
                            <th>SL. No.</th>
                            <th>Child Name</th>
                            {/* <th>Offering</th> */}
                            <th>Attendance</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {executionHistory.map((execution, index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>{execution.child.name}</td>
                              {/* <td>
                                <Badge
                                  style={{
                                    backgroundColor: execution.batch.offering.color,
                                    padding: '8px 15px',
                                    fontSize: '14px'
                                  }}
                                  pill
                                >
                                  {execution.batch.offering.name}
                                </Badge>
                              </td> */}
                              <td>
                                <Badge
                                  color={execution.isPresent ? 'success' : 'danger'}
                                >
                                  {execution.isPresent ? 'Present' : 'Absent'}
                                </Badge>
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => openViewModal(execution)}
                                    title="View multimedia"
                                    className='mr-2'
                                  >
                                    <i className="fas fa-eye mr-2"></i>

                                    View
                                  </Button>

                                  
                                    <Button
                                      size="sm"
                                      color="success"
                                      onClick={() => handlePublishExecution(execution._id)}
                                      className='mr-2'
                                      disabled={!execution.draft}
                                    >
                                      <i className="fas fa-upload mr-2"></i>
                                      Publish
                                    </Button>
                                  
                                  {validatePermissionKey(
                                    props.authUser,
                                    UPDATE_EXECUTION
                                  ) && (
                                      <Button
                                        size="sm"
                                        color="warning"
                                        onClick={() => openUpdateExecutionModal(execution._id)}
                                        title="Edit execution"
                                        className='mr-2'

                                      >
                                        <i className="fas fa-edit mr-2"></i>
                                        Edit
                                      </Button>
                                    )}

                                  {validatePermissionKey(
                                    props.authUser,
                                    DELETE_EXECUTION
                                  ) && (
                                      <Button
                                        size="sm"
                                        color="danger"
                                        onClick={() => {
                                          openDeleteExecutionModal(
                                            execution._id,
                                            execution.isDeleted ? 'restore' : 'delete'
                                          );
                                        }}
                                        title={execution.isDeleted ? 'Restore execution' : 'Delete execution'}
                                      >
                                        {execution.isDeleted ? (
                                          <i className="fas fa-trash-restore mr-2"></i>
                                        ) : (
                                          <i className="fas fa-trash mr-2"></i>
                                        )}
                                        {execution.isDeleted ? 'Restore' : 'Delete'}
                                      </Button>
                                    )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </AvForm>
              </CardBody>
            </Card>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

function AddBatchExecutionModal(props) {
  const [executionArray, setExecutionArray] = useState([]);
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });
  const [addExecutionRequestLoading, setAddExecutionRequestLoading] = useState(false);
  const [addBulkRequestLoading, setAddBulkRequestLoading] = useState(false);
  const [formError, setFormError] = useState('');

  // Get all child IDs that already have executions
  const existingChildIds = props.existingExecutions.map(
    execution => execution.child._id
  );

  // Filter child options to exclude children with existing executions
  const filteredChildOptions = props.childOptions.filter(
    child => !existingChildIds.includes(child.value)
  );

  // Initialize execution array when modal opens
  useEffect(() => {
    if (props.addExecutionModalVisible) {
      // Reset states when modal opens
      setRequestError({ show_alert: false, message: '' });
      setFormError('');
      setAddExecutionRequestLoading(false);
      setAddBulkRequestLoading(false);

      // Start with one empty row for new execution
      setExecutionArray([{
        batch: props.batchId,
        child: '',
        note: '',
        isPresent: true,
        images: [],
        links: [],
        currentYoutubeLink: '',
        multimediaOpen: false,
      }]);
    }
  }, [props.addExecutionModalVisible]);

  // Update images for specific child
  const updateImagesForIndex = (index, newImages) => {
    const newExecutionArray = [...executionArray];
    newExecutionArray[index].images = newImages;
    setExecutionArray(newExecutionArray);
  };

  // Update current YouTube link for specific child
  const updateCurrentYoutubeLinkForIndex = (index, value) => {
    const newExecutionArray = [...executionArray];
    newExecutionArray[index].currentYoutubeLink = value;
    setExecutionArray(newExecutionArray);
  };

  // Add YouTube link to specific child
  const handleButtonClick = (index) => {
    resetErrorAlert();
    const currentLink = executionArray[index].currentYoutubeLink;

    if (!isValidYouTubeLink(currentLink)) {
      showErrorAlert("Enter valid YouTube link!");
      return;
    }

    const trimmedLink = currentLink.trim();
    if (trimmedLink !== '') {
      setExecutionArray(prev => {
        const newArray = [...prev];
        newArray[index].links = [...newArray[index].links, trimmedLink];
        newArray[index].currentYoutubeLink = '';
        return newArray;
      });
    }
  };

  // Remove YouTube link from specific child
  const handleRemoveLink = (index, linkToRemove) => {
    setExecutionArray(prev => {
      const newArray = [...prev];
      newArray[index].links = newArray[index].links.filter(link => link !== linkToRemove);
      return newArray;
    });
  };

  async function handleSaveExecution(event, values) {
    resetErrorAlert();
    setFormError('');

    // Validate form
    const hasErrors = executionArray.some((e, index) => {
      if (!e.child) {
        showErrorAlert(`Please select a child for execution #${index + 1}`);
        return true;
      }

      if (props.noteRequired !== false && e.note.trim() === '') {
        showErrorAlert(`Please enter a note for ${e.child.label}`);
        return true;
      }

      return false;
    });

    if (hasErrors) return;

    setAddExecutionRequestLoading(true);
    let success = true;

    for (const e of executionArray) {
      try {
        const form = new FormData();
        form.set('batch', e.batch);
        form.set('date', props.date);
        form.set('child', e.child.value);
        form.set('note', e.note);
        form.set('isPresent', e.isPresent);
        form.set('links', JSON.stringify(e.links));
        form.set('draft', true);

        // Add images
        if (e.images.length > 0) {
          e.images.forEach(g => form.append('images', g));
        }

        // Create new execution
        const { error } = await addNewBatchExecution(form);
        if (error) throw new Error('Error adding execution');
      } catch (err) {
        showErrorAlert(err.message || 'Error processing execution');
        success = false;
        break;
      }
    }

    setAddExecutionRequestLoading(false);
    if (success) {
      props.showSuccessAlert('Executions saved successfully');
      props.close();
      props.setReload(!props.reload);
    }
  }

  async function handlePublishExecution(event, values) {
    resetErrorAlert();
    setFormError('');

    // Validate form
    const hasErrors = executionArray.some((e, index) => {
      if (!e.child) {
        showErrorAlert(`Please select a child for execution #${index + 1}`);
        return true;
      }

      if (props.noteRequired !== false && e.note.trim() === '') {
        showErrorAlert(`Please enter a note for ${e.child.label}`);
        return true;
      }

      return false;
    });

    if (hasErrors) return;

    setAddBulkRequestLoading(true);
    let success = true;

    for (const e of executionArray) {
      try {
        const form = new FormData();
        form.set('batch', e.batch);
        form.set('date', props.date);
        form.set('child', e.child.value);
        form.set('note', e.note);
        form.set('isPresent', e.isPresent);
        form.set('links', JSON.stringify(e.links));
        form.set('draft', false);

        // Add images
        if (e.images.length > 0) {
          e.images.forEach(g => form.append('images', g));
        }

        // Create new execution
        const { error } = await addNewBatchExecution(form);
        if (error) throw new Error('Error adding execution');
      } catch (err) {
        showErrorAlert(err.message || 'Error processing execution');
        success = false;
        break;
      }
    }

    setAddBulkRequestLoading(false);
    if (success) {
      props.showSuccessAlert('Executions published successfully');
      props.close();
      props.setReload(!props.reload);
    }
  }

  function handleChildSelection(index, selectedItem) {
    const newExecutionArray = [...executionArray];
    newExecutionArray[index].child = selectedItem;
    setExecutionArray(newExecutionArray);
  }

  function handleNote(index, e) {
    resetErrorAlert();
    const newExecutionArray = [...executionArray];
    newExecutionArray[index].note = e.target.value;
    setExecutionArray(newExecutionArray);
  }

  // Updated to handle checkbox change
  function handleIsPresent(index, value) {
    resetErrorAlert();
    const newExecutionArray = [...executionArray];
    newExecutionArray[index].isPresent = value;
    setExecutionArray(newExecutionArray);
  }

  const toggleMultimedia = (index) => {
    const newExecutionArray = [...executionArray];
    newExecutionArray[index].multimediaOpen = !newExecutionArray[index].multimediaOpen;
    setExecutionArray(newExecutionArray);
  };

  const removeExecutionFields = (index) => {
    const newExecutionArray = [...executionArray];
    newExecutionArray.splice(index, 1);
    setExecutionArray(newExecutionArray);
  };

  const addExecutionFields = () => {
    // Only add if there are available children
    if (filteredChildOptions.length > executionArray.length) {
      setExecutionArray(prev => [
        ...prev,
        {
          batch: props.batchId,
          child: '',
          note: '',
          isPresent: true,
          images: [],
          links: [],
          currentYoutubeLink: '',
          multimediaOpen: false,
        }
      ]);
    }
  };

  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  // Show message when no children available
  if (filteredChildOptions.length === 0) {
    return (
      <Modal isOpen={props.addExecutionModalVisible} backdrop="static" size="xl">
        <ModalHeader>Add Executions for {moment(props.date).format('DD-MM-YYYY')}</ModalHeader>
        <ModalBody>
          <Alert color="info">
            All children already have executions for this date.
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={props.close}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  // Function to get available options for each row (exclude already selected children)
  const getChildOptionsForRow = (index) => {
    // Get child IDs selected in other rows
    const selectedChildIds = executionArray
      .filter((_, idx) => idx !== index)
      .map(row => row.child?.value)
      .filter(id => id); // remove undefined

    return filteredChildOptions.filter(
      child => !selectedChildIds.includes(child.value)
    );
  };

  return (
    <Modal isOpen={props.addExecutionModalVisible} backdrop="static" size="xl">
      <ModalHeader>Add Executions for {moment(props.date).format('DD-MM-YYYY')}</ModalHeader>
      <ModalBody>
        {requestError.show_alert && (
          <Alert color="danger">{requestError.message}</Alert>
        )}
        {formError && <Alert color="danger">{formError}</Alert>}

        {executionArray.map((element, index) => (
          <div
            key={index}
            className="p-3 border rounded mb-3"
          >
            <Row>
              <Col md="6" style={{ display: 'flex', flexDirection: 'column' }}>
                <FormGroup>
                  <Label>Child</Label>
                  <Select
                    options={getChildOptionsForRow(index)}
                    onChange={(e) => handleChildSelection(index, e)}
                    value={element.child}
                  />
                </FormGroup>
                <FormGroup>
                  {/* <Label>Attendance</Label> */}
                  <div className="d-flex align-items-center">
                    <FormGroup check className="mr-3">
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={element.isPresent}
                          onChange={(e) => handleIsPresent(index, e.target.checked)}
                        />{' '}
                        Present
                      </Label>
                    </FormGroup>
                  </div>
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label>Note{props.noteRequired === false ? ' (optional)' : ''}</Label>
                  <Input
                    type="textarea"
                    name="note"
                    placeholder="Enter Note ..."
                    rows="3"
                    className="form-control"
                    onChange={(e) => handleNote(index, e)}
                    value={element.note}
                  />
                </FormGroup>

              </Col>
            </Row>


            <div className="d-flex justify-content-between align-items-center mb-2">
              <Button
                color="info"
                size="sm"
                onClick={() => toggleMultimedia(index)}
              >
                {element.multimediaOpen ? "Hide Multimedia" : "Add Multimedia"}
              </Button>
              {/* <Button
                size="sm"
                color="danger"
                onClick={() => removeExecutionFields(index)}
              >
                Remove
              </Button> */}
            </div>

            <Collapse isOpen={element.multimediaOpen}>
              <div className="border rounded p-3 bg-light">
                <h6 className="mb-3">Multimedia Content</h6>
                <FormGroup>
                  <Label>Upload Images/Videos</Label>
                  <FormUpload
                    setImages={(newImages) => updateImagesForIndex(index, newImages)}
                    multiple={true}
                    title="Upload Images or Videos"
                    video={true}
                    existingImages={element.images}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>YouTube Links</Label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fab fa-youtube text-danger" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="text"
                      placeholder="Enter YouTube link"
                      value={element.currentYoutubeLink}
                      onChange={(e) => updateCurrentYoutubeLinkForIndex(index, e.target.value)}
                    />
                    <InputGroupAddon addonType="append">
                      <Button
                        color="primary"
                        onClick={() => handleButtonClick(index)}
                      >
                        Add
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>

                  {element.links?.length > 0 && (
                    <div className="mt-3">
                      <ul className="list-group">
                        {element.links.map((link, linkIndex) => (
                          <li
                            key={linkIndex}
                            className="list-group-item d-flex justify-content-between align-items-center py-2"
                          >
                            <a
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-truncate"
                              style={{ maxWidth: '80%' }}
                            >
                              {link}
                            </a>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleRemoveLink(index, link)}
                            >
                              <i className="fas fa-times"></i>
                            </Button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </FormGroup>
              </div>
            </Collapse>
          </div>
        ))}

        {/* <Row className="mt-2 mb-2">
          <Col className="d-flex justify-content-start align-items-center">
            <Button
              size="sm"
              color="info"
              className="mr-2"
              onClick={addExecutionFields}
              disabled={filteredChildOptions.length <= executionArray.length}
            >
              Add Another Child
            </Button>
          </Col>
        </Row> */}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={props.close}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSaveExecution}
          disabled={addExecutionRequestLoading || addBulkRequestLoading}
        >
          {addExecutionRequestLoading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              Saving...
            </>
          ) : (
            'Save as Draft'
          )}
        </Button>
        <Button
          color="success"
          onClick={handlePublishExecution}
          disabled={addExecutionRequestLoading || addBulkRequestLoading}
        >
          {addBulkRequestLoading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              Publishing...
            </>
          ) : (
            'Publish'
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(AddBatchExecution);